<template>
  <div>
    <div class="mian">
      <div class="left">
        <img src="" alt="" />
      </div>
      <div class="right">
        <p class="name">兑换维达抽纸巾</p>
        <p class="line_comp1 col_gray">领取方式：自取</p>
        <p class="line_comp1 col_gray">商家：苏果超市（坝子街店）</p>
        <p class="line_comp1 col_gray">地址：鼓楼区坝子街9号1513</p>
        <p class="line_comp1 col_gray">货码：下单后生成</p>
        <p class="line_comp1 col_gray">兑换日期：2021-05-16 10：36：13</p>
      </div>
    </div>
    <div>消耗积分 <span>1000积分</span></div>
    <div>
      <div class="btn">确认提交</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.mian {
  padding: 0.3rem 0.4rem;
  display: flex;
  .left {
    flex: 0 1 45%;
  }
  .right {
    font-size: 0.26rem;
    flex: 0 1 55%;
    p {
      padding-top: 0.1rem;
    }
  }
  .name {
    font-weight: 900;
  }
}
.btn {
  width: 40%;
  text-align: center;
  margin: 0 auto;
  padding: 0.2rem 0;
  color: #fff;
  background: #007fff;
}
</style>